import React from 'react';

import { fg } from '@atlaskit/platform-feature-flags';

import { OverflowAvatarStack } from '../OverflowAvatarStack';
import * as Styled from '../styles';
import { type ReportingLinesUser } from '../types';

import { ReportingLinesUserCardWithLine } from './shared';

interface ManagerSectionProps {
	orderedManagerList: ReportingLinesUser[];
	showAvatarStack: boolean;
	toggleAvatarStack: () => void;
	isSelectedUserManager: boolean;
}

export const ManagerSection = ({
	orderedManagerList,
	showAvatarStack,
	toggleAvatarStack,
	isSelectedUserManager,
}: ManagerSectionProps): React.JSX.Element => {
	const unstackedManagerLimit = isSelectedUserManager ? 1 : 2;
	const firstManager = orderedManagerList.at(-1);

	return (
		<>
			{orderedManagerList.length > unstackedManagerLimit + 1 && showAvatarStack ? (
				<>
					{firstManager && fg('remove_nested_elements_reporting_lines') && (
						<ReportingLinesUserCardWithLine user={firstManager} testId="direct-manager-card" />
					)}
					<Styled.ManagerAvatarStackWrapper key="manager-avatars" testId="manager-avatars">
						<OverflowAvatarStack
							atlassianUsers={
								fg('remove_nested_elements_reporting_lines')
									? orderedManagerList.slice(unstackedManagerLimit + 1).reverse()
									: orderedManagerList.slice(unstackedManagerLimit).reverse()
							}
							numFilteredMissingProfiles={0}
							avatarSize="small"
							onClick={toggleAvatarStack}
							includeNameInMoreText
						/>
					</Styled.ManagerAvatarStackWrapper>
					<Styled.VerticalChartLine />
				</>
			) : (
				orderedManagerList
					.slice(unstackedManagerLimit)
					.map((manager) => (
						<ReportingLinesUserCardWithLine
							user={manager}
							key={manager.accountIdentifier ?? undefined}
						/>
					))
					.reverse()
			)}
			{isSelectedUserManager
				? null
				: orderedManagerList[1] && (
						<ReportingLinesUserCardWithLine
							user={orderedManagerList[1]}
							testId="skip-manager-card"
						/>
					)}
			{orderedManagerList[0] && (
				<ReportingLinesUserCardWithLine user={orderedManagerList[0]} testId="direct-manager-card" />
			)}
		</>
	);
};
